export default __webpack_public_path__ + "static/media/LinkedIn-blue.b37ff090.svg";